import { render, staticRenderFns } from "./register-layout.vue?vue&type=template&id=f870eaa6&scoped=true&"
import script from "./register-layout.vue?vue&type=script&lang=js&"
export * from "./register-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f870eaa6",
  null
  
)

export default component.exports